import { HighTechSoftwarePageProvider } from "../../context/industryPageProviders";
import IndustryPageLayout from "./IndustryPageLayout";

export default function HighTechSoftware() {
  return (
    <HighTechSoftwarePageProvider>
      <IndustryPageLayout />
    </HighTechSoftwarePageProvider>
  );
}
